import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AppointmentActionModalBase } from '../../shared/base/appointment-action-modal.base';

@Component({
  selector: 'app-mark-complete-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './mark-complete-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mark-complete-modal.component.scss',
})
export class MarkCompleteModalComponent extends AppointmentActionModalBase {}
